import React from 'react';
import { StyleSheet, ActivityIndicator } from 'react-native';
import { Image } from '@rneui/themed';

const styles = StyleSheet.create({
    imageContent: {
        aspectRatio: 1,
        width: '50%',
        justifyContent: 'center',
    },
});

interface ImageFieldProps {
    data: {
        image: string;
    };
}

const ImageField: React.FC<ImageFieldProps> = ({ data }) => {
    return (
        <Image
            source={{
                uri: typeof data === 'object' ? data.image : '',
            }}
            containerStyle={styles.imageContent}
            PlaceholderContent={<ActivityIndicator />}
        />
    );
};

export default ImageField;
